export const mockData = {
  company: {
    name: "Insat Techno Services",
    tagline: "Intelligent Systems. Seamless Integration.",
    description: "Leading provider of comprehensive systems integration solutions for modern enterprises. We specialize in security, safety, and communication technologies that protect, connect, and empower your organization.",
    email: "info@insattechno.co.in",
    phone: "+91 172 2712911",
    address: "SCO-53, Sector 20-C, Chandigarh, 160020"
  },
  
  services: [
    {
      id: 1,
      title: "CCTV Surveillance Systems",
      description: "Advanced IP-based surveillance solutions with AI-powered analytics, remote monitoring, and 24/7 recording capabilities for complete security coverage.",
      image: "https://images.unsplash.com/photo-1585206031650-9e9a7c87dcfe",
      features: ["IP & Analog Cameras", "AI Analytics", "Remote Monitoring", "Cloud Storage"]
    },
    {
      id: 2,
      title: "Fire Alarm Systems",
      description: "Comprehensive fire detection and alarm systems designed to meet safety regulations and protect lives with intelligent monitoring and rapid response.",
      image: "https://images.unsplash.com/photo-1653353436174-a8e724190fd3",
      features: ["Smoke Detection", "Heat Sensors", "Alarm Panels", "Emergency Notification"]
    },
    {
      id: 3,
      title: "PA Systems",
      description: "Professional public address systems delivering crystal-clear audio for announcements, emergency communications, and background music across your facility.",
      image: "https://images.unsplash.com/photo-1619386113777-f92dd987bfb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxhdWRpbyUyMGVxdWlwbWVudHxlbnwwfHx8fDE3NjA4NTA4MzN8MA&ixlib=rb-4.1.0&q=85",
      features: ["Zone Control", "Emergency Override", "Digital Amplifiers", "Distributed Audio"]
    },
    {
      id: 4,
      title: "Audio-Visual Systems",
      description: "State-of-the-art AV solutions for conference rooms, training centers, and corporate spaces with seamless integration and user-friendly controls.",
      image: "https://images.unsplash.com/photo-1582653291997-079a1c04e5a1",
      features: ["Video Conferencing", "Display Systems", "Control Systems", "Room Automation"]
    },
    {
      id: 5,
      title: "Digital Signage",
      description: "Dynamic digital display solutions for engaging content delivery, wayfinding, and corporate communications with centralized management.",
      image: "https://images.unsplash.com/flagged/photo-1572609239482-d3a83f976aa0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxMRUQlMjBkaXNwbGF5fGVufDB8fHx8MTc2MDg1MDgzOHww&ixlib=rb-4.1.0&q=85",
      features: ["LED Displays", "Content Management", "Interactive Kiosks", "Video Walls"]
    }
  ],
  
  /* 
   * HOW TO ADD/EDIT CASE STUDIES:
   * 1. Each case study should have: id, title, client, description, image (URL), services (array), results
   * 2. Simply add a new object to the array below or edit existing ones
   * 3. The layout will automatically adjust to display all case studies
   * 4. Image should be a valid URL (can use Unsplash or other image hosting)
   * 5. Services array should list the services provided for that project
   */
  caseStudies: [
    {
      id: 1,
      title: "Global Corporate Headquarters",
      client: "Fortune 500 Technology Company",
      description: "Complete AV integration across 15 conference rooms and 3 auditoriums with unified control systems and video conferencing capabilities.",
      image: "https://images.unsplash.com/photo-1760346546767-95b89356a6bb",
      services: ["Audio-Visual Systems", "Digital Signage"],
      results: "Enhanced collaboration efficiency by 45%, reduced meeting setup time by 70%"
    },
    {
      id: 2,
      title: "Retail Chain Security Upgrade",
      client: "National Retail Corporation",
      description: "Deployed 500+ IP cameras across 50 retail locations with centralized monitoring and AI-powered analytics for loss prevention.",
      image: "https://images.unsplash.com/photo-1534858959090-1a01fbb48a61",
      services: ["CCTV Surveillance", "Fire Alarm Systems"],
      results: "Reduced theft incidents by 62%, improved emergency response time by 80%"
    },
    {
      id: 3,
      title: "Educational Campus Integration",
      client: "Premier University",
      description: "Comprehensive security and communication infrastructure including CCTV, fire alarms, and PA systems across 25 buildings.",
      image: "https://images.unsplash.com/photo-1530151928300-3864d0e5d178",
      services: ["CCTV Surveillance", "Fire Alarm Systems", "PA Systems"],
      results: "Complete campus coverage, 99.9% system uptime, enhanced safety protocols"
    }
  ],
  
  partners: [
    { 
      name: "CISCO",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/93pp3i3k_image.png"
    },
    { 
      name: "MICROSOFT",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/3j3ktwm6_image.png"
    },
    { 
      name: "HONEYWELL",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/fv6j3nbr_image.png"
    },
    { 
      name: "BOSCH",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/onikg3az_image.png"
    },
    { 
      name: "CRESTRON",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/tol6nqjv_image.png"
    },
    { 
      name: "SAMSUNG",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/th0mrdy3_image.png"
    },
    { 
      name: "KRAMER",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/phedmitn_image.png"
    },
    { 
      name: "PANASONIC",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/456hmknu_image.png"
    },
    { 
      name: "SENNHEISER",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/a7p87593_image.png"
    },
    { 
      name: "SONY",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/t2jhyoyt_image.png"
    },
    { 
      name: "LG",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/dx0wtfyt_image.png"
    },
    { 
      name: "DELL",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/owyiu7mh_image.png"
    },
    { 
      name: "HP",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/x8iigkoj_image.png"
    },
    { 
      name: "HIKVISION",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/hkxoq2lo_image.png"
    },
    { 
      name: "AXIS",
      logo: "https://customer-assets.emergentagent.com/job_av-security-experts/artifacts/hq3qlau1_image.png"
    }
  ],
  
  stats: [
    { number: "500+", label: "Projects Completed" },
    { number: "30+", label: "Years Experience" },
    { number: "98%", label: "Client Satisfaction" },
    { number: "24/7", label: "Support Available" }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "John Mitchell",
      position: "IT Director",
      company: "Tech Corp International",
      quote: "Insat Techno Services transformed our security infrastructure with professionalism and expertise. Their attention to detail and ongoing support is exceptional."
    },
    {
      id: 2,
      name: "Sarah Williams",
      position: "Facilities Manager",
      company: "Global Retail Solutions",
      quote: "The integration of our fire alarm and surveillance systems was seamless. The team's technical knowledge and project management skills are outstanding."
    },
    {
      id: 3,
      name: "Dr. Robert Chen",
      position: "Campus Safety Director",
      company: "State University",
      quote: "Working with Insat was a game-changer for our campus security. Their comprehensive approach and reliable systems give us peace of mind every day."
    }
  ]
};